import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import * as apps from '../../enums/apps';
import { getHeaderComponent } from './getHeaderComponent';
import './styles.scss';

const DrawerHeader = ({ drawerType, count, active, onClick }) => (
    <header>{getHeaderComponent({ drawerType, count, active, onClick })}</header>
);

DrawerHeader.propTypes = {
    drawerType: propTypes.string,
    active: propTypes.string,
    onClick: propTypes.func,
    count: propTypes.shape({
        [apps.APP_NAME_INBOX]: propTypes.number,
        [apps.APP_NAME_NOTIFICATIONS]: propTypes.number,
    }),
};

export default connect(({ count }) => ({ count }))(DrawerHeader);
